import React, {Component, useRef, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Chip from '@material-ui/core/Chip';
import {Block} from '@material-ui/icons';
import {Avatar} from "@material-ui/core";
import styled from "styled-components";
import Slider from "react-slick";

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit,
  },
});


class ChipBar extends Component{
  constructor(props) {
    super(props);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.state = {
      slidesToScroll: 1,
      autoplay: false,
    }
  }

  play = () => this.slider.slickPlay();
  pause = () => this.slider.slickPause();

  render = () => {
    const settings = {
      autoplay: this.state.autoplay,
      autoplaySpeed: 200,
      arrows: false,
      dots: false,
      slidesToScroll: this.state.slidesToScroll,
      variableWidth: true,
      infinite: false,
    }
    const {chips, onClick, selectedChips} = this.props;

    return (
      <ChipBarDivBox>
        <div
          onMouseEnter={() => {
            this.play();
            this.setState({slidesToScroll: -1, autoplay: true})
          }}
          onMouseLeave={() => {
            this.pause()
            this.setState({slidesToScroll: -1, autoplay: false})
          }}
          className={"tag-carousel-border"}
          style={{left: 0, background: "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)"}}
        />
        <Slider ref={slider => (this.slider = slider)}  {...settings} style={{width: "100%", position: "relative", float: "left"}}>
          {chips.map((chip, j) =>
            <div className={`smart-search-tag-containter`}
                 style={{position: "relative", float: "left", margin: "0px 5px"}}>
              {chip.state !== 'disable' ?
                <Chip
                  key={j}
                  avatar={chip.state === 'unselected' &&
                  <Avatar style={{width: 23, height: 23, backgroundColor: "rgb(208, 55, 55)"}}>
                    <Block style={{color: "white"}}/>
                  </Avatar>
                  }
                  style={{
                    width: "auto",
                    fontWeight: "400",
                    backgroundColor: selectedChips.includes(chip.id.toString()) ? 'black' : 'white',
                    color: selectedChips.includes(chip.id.toString()) ? 'white' : 'black',
                    cursor: 'pointer',
                    height: "30px",
                    marginTop: "3px",
                    marginBottom: "3px",
                    border: !['selected', 'unselected'].includes(chip.state) && '1px solid #c0c0c0',
                  }}
                  className={"chip-bar-chips"}
                  label={<span style={{
                    color: selectedChips.includes(chip.id.toString()) ? "white" : "rgb(110 110 110)",
                    letterSpacing: -0.5,
                    fontSize: 11
                  }}>{chip.name}</span>}
                  onClick={(e) => onClick(chip.id.toString())}
                /> :
                <Chip key={j}
                      style={{
                        width: "auto",
                        fontWeight: "400",
                        backgroundColor: 'transparent',
                        color: 'rgba(191,191,191,0.55)',
                        cursor: 'default',
                        height: "30px",
                        marginTop: "3px",
                        marginBottom: "3px",
                        border: '1px solid #e9e9e9',
                      }}
                      className={"chip-bar-chips"}
                      label={<span style={{
                        color: selectedChips.includes(chip.id.toString()) ? "white" : "rgb(110 110 110)",
                        letterSpacing: -0.5,
                        fontSize: 11
                      }}>{chip.name}</span>}
                />
              }
            </div>
          )}
        </Slider>
        <div
          onMouseEnter={() => {
            this.play();
            this.setState({slidesToScroll: 1, autoplay: true})
          }}
          onMouseLeave={() => {
            this.pause()
            this.setState({slidesToScroll: 1, autoplay: false})
          }}
          style={{right: 0, background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)"}}
          className={"tag-carousel-border"}
        />
      </ChipBarDivBox>
    )
  }
}

export default withStyles(styles)(ChipBar);

const ChipBarDivBox = styled.div`
  float: left;
  position: relative;
  width: 100%;
  padding: 10px 0px;
  border-bottom: 1px solid rgba(0,0,0,.1);
  border-top: 1px solid rgba(0,0,0,.1);
  margin-bottom: 15px;
`;
